import { render } from "./FleetUpdate.vue?vue&type=template&id=4a2f8e94&scoped=true"
import script from "./FleetUpdate.vue?vue&type=script&lang=js"
export * from "./FleetUpdate.vue?vue&type=script&lang=js"

import "./FleetUpdate.vue?vue&type=style&index=0&id=4a2f8e94&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2f8e94"]])

export default __exports__